import { MONERIS } from '@client/actions';
import { Action } from '@client/lib/action';

export class MonerisHydrateAction implements Action {
	readonly type = MONERIS.HYDRATE;
	constructor(public payload: any, public correlationId?: number) {}
}
